export default __webpack_public_path__ + "static/media/PartywearPolaBangles.dbce6f86.jpg";